import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ThemeToggle } from "@/components/ThemeToggle";
import { toast } from "sonner";
import { Lock, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("A senha deve ter ao menos 6 caracteres"); return; }
    if (password !== confirm) { toast.error("As senhas não coincidem"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Senha alterada com sucesso!");
      setTimeout(() => navigate("/login"), 1800);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erro ao redefinir senha");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background relative">
      <div className="absolute top-4 right-4"><ThemeToggle /></div>
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-6">
          <img src="/np-logo.png" alt="NotaHoje" className="h-10 w-10 rounded-lg object-contain bg-white border border-border p-0.5" />
          <span className="font-display font-extrabold text-xl">NotaHoje</span>
        </div>
        {!token ? (
          <p className="text-muted-foreground">Link inválido. Solicite a recuperação novamente na tela de login.</p>
        ) : done ? (
          <div className="text-center space-y-3">
            <CheckCircle2 className="h-14 w-14 mx-auto text-secondary" />
            <h1 className="font-display font-extrabold text-2xl">Senha alterada!</h1>
            <p className="text-muted-foreground">Redirecionando para o login...</p>
          </div>
        ) : (
          <>
            <h1 className="font-display font-extrabold text-3xl">Criar nova senha</h1>
            <p className="text-muted-foreground mt-1">Digite sua nova senha de acesso.</p>
            <form onSubmit={submit} className="space-y-4 mt-6">
              <div>
                <Label>Nova senha</Label>
                <div className="relative mt-1"><Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                  <Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="pl-10 h-12" data-testid="reset-password-input" /></div>
              </div>
              <div>
                <Label>Confirmar senha</Label>
                <div className="relative mt-1"><Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                  <Input required type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="pl-10 h-12" data-testid="reset-confirm-input" /></div>
              </div>
              <Button type="submit" disabled={loading} className="w-full h-12" data-testid="reset-submit-btn">{loading ? "Salvando..." : "Redefinir senha"}</Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
